module.exports = __webpack_public_path__ + "img/banner-slider.1a047040.webp";